export default {
    category: {
        cta: "View Products"
    }
}